import { DefaultState } from '@src/redux/types'

import {
  DEMO_LESSON_COURSE,
  DEMO_LESSON_COURSE_ALL,
  DEMO_LESSON_COURSE_CREATE,
  DEMO_LESSON_COURSE_DELETE,
  DEMO_LESSON_COURSE_LIST,
  DEMO_LESSON_EVALUATION_ASSIGNED,
  DEMO_LESSON_EVALUATION_CATEGORY,
  DEMO_LESSON_EVALUATION_CREATE,
  DEMO_LESSON_EVALUATION_LIST,
  DEMO_LESSON_EVALUATION_PRINCIPAL,
  DEMO_LESSON_EVALUATION_REPORT,
  DEMO_LESSON_EVALUATION_RESPONSE_ALL,
  DEMO_LESSON_EVALUATION_RESPONSE_CREATE,
  DEMO_LESSON_MODULE,
  DEMO_LESSON_MODULE_ALL,
  DEMO_LESSON_MODULE_CREATE,
  DEMO_LESSON_MODULE_DELETE,
  DEMO_LESSON_MODULE_LIST,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [DEMO_LESSON_EVALUATION_CREATE]: DefaultState<`${typeof API.DEMO_LESSON_EVALUATION}`, 'post'>
  [DEMO_LESSON_EVALUATION_LIST]: DefaultState<`${typeof API.DEMO_LESSON_EVALUATION}`, 'get'>
  [DEMO_LESSON_EVALUATION_CATEGORY]: DefaultState<`${typeof API.DEMO_LESSON_EVALUATION_CATEGORY}`, 'get'>
  [DEMO_LESSON_EVALUATION_PRINCIPAL]: DefaultState<`${typeof API.DEMO_LESSON_EVALUATION_PRINCIPAL}`, 'get'>
  [DEMO_LESSON_EVALUATION_RESPONSE_CREATE]: DefaultState<`${typeof API.DEMO_LESSON_EVALUATION_RESPONSE}`, 'post'>
  [DEMO_LESSON_EVALUATION_RESPONSE_ALL]: DefaultState<`${typeof API.DEMO_LESSON_EVALUATION_RESPONSE_ALL}`, 'get'>
  [DEMO_LESSON_EVALUATION_ASSIGNED]: DefaultState<`${typeof API.DEMO_LESSON_EVALUATION_ASSIGNED}`, 'get'>
  [DEMO_LESSON_COURSE]: DefaultState<`${typeof API.DEMO_LESSON_COURSE}`, 'get'>
  [DEMO_LESSON_COURSE_CREATE]: DefaultState<`${typeof API.DEMO_LESSON_COURSE}`, 'post'>
  [DEMO_LESSON_COURSE_DELETE]: DefaultState<`${typeof API.DEMO_LESSON_COURSE}{id}`, 'delete'>
  [DEMO_LESSON_COURSE_LIST]: DefaultState<`${typeof API.DEMO_LESSON_COURSE}`, 'get'>
  [DEMO_LESSON_COURSE_ALL]: DefaultState<`${typeof API.DEMO_LESSON_COURSE_ALL}`, 'get'>
  [DEMO_LESSON_MODULE]: DefaultState<`${typeof API.DEMO_LESSON_MODULE}`, 'get'>
  [DEMO_LESSON_MODULE_CREATE]: DefaultState<`${typeof API.DEMO_LESSON_MODULE}`, 'post'>
  [DEMO_LESSON_MODULE_DELETE]: DefaultState<`${typeof API.DEMO_LESSON_MODULE}{id}`, 'delete'>
  [DEMO_LESSON_MODULE_LIST]: DefaultState<`${typeof API.DEMO_LESSON_MODULE}`, 'get'>
  [DEMO_LESSON_MODULE_ALL]: DefaultState<`${typeof API.DEMO_LESSON_MODULE_ALL}`, 'get'>
  [DEMO_LESSON_EVALUATION_REPORT]: DefaultState<`${typeof API.DEMO_LESSON_EVALUATION_REPORT}{id}`, 'get'>
} = () => ({
  [DEMO_LESSON_EVALUATION_CREATE]: defaultState(),
  [DEMO_LESSON_EVALUATION_LIST]: defaultState(),
  [DEMO_LESSON_EVALUATION_CATEGORY]: defaultState(),
  [DEMO_LESSON_EVALUATION_PRINCIPAL]: defaultState(),
  [DEMO_LESSON_EVALUATION_RESPONSE_CREATE]: defaultState(),
  [DEMO_LESSON_EVALUATION_RESPONSE_ALL]: defaultState(),
  [DEMO_LESSON_EVALUATION_ASSIGNED]: defaultState(),
  [DEMO_LESSON_COURSE]: defaultState(),
  [DEMO_LESSON_COURSE_ALL]: defaultState(),
  [DEMO_LESSON_COURSE_LIST]: defaultState(),
  [DEMO_LESSON_COURSE_CREATE]: defaultState(),
  [DEMO_LESSON_COURSE_DELETE]: defaultState(),
  [DEMO_LESSON_MODULE]: defaultState(),
  [DEMO_LESSON_MODULE_ALL]: defaultState(),
  [DEMO_LESSON_MODULE_LIST]: defaultState(),
  [DEMO_LESSON_MODULE_CREATE]: defaultState(),
  [DEMO_LESSON_MODULE_DELETE]: defaultState(),
  [DEMO_LESSON_EVALUATION_REPORT]: defaultState(),
})
